import { render, staticRenderFns } from "./AddRecipeModal.vue?vue&type=template&id=206232d2&"
import script from "./AddRecipeModal.vue?vue&type=script&lang=js&"
export * from "./AddRecipeModal.vue?vue&type=script&lang=js&"
import style0 from "./AddRecipeModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports